export default () => {
  return {
    params: {},
    searchResults: [],
    Workspace: { results: [], isLoading: false, errors: [] },
    Grid: { results: [], isLoading: false, errors: [] },
    Chart: { results: [], isLoading: false, errors: [] },
    Metric: { results: [], isLoading: false, errors: [] },
    Distribution: { results: [], isLoading: false, errors: [] },
    Trigger: { results: [], isLoading: false, errors: [] },
    Group: { results: [], isLoading: false, errors: [] },
    Discussion: { results: [], isLoading: false, errors: [] },
    User: { results: [], isLoading: false, errors: [] },
    errors: [],
    isLoading: false,
    success: false,
    showSearchResults: false
  }
}
